<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@if (facade.isVisible$ | async) {
  @if (facade.hasActivated$ | async) {
    <div class="zero-surface secondary-800 mb-4 p-4 b-r-8">
      <div class="d-flex justify-content-between align-items-center">
        <h5 class="zero-text p-base-bold dark-green mb-2">
          {{ 'my-home.my-home-page.dividend-re-invest-hint.success.headline' | transloco }}
        </h5>
        <web-design-system-icon name="cross" aria-label="Close" class="cursor-pointer" color="green" (click)="facade.close()" />
      </div>
      <p class="zero-text p-small-reg dark-green">{{ 'my-home.my-home-page.dividend-re-invest-hint.success.text' | transloco }}</p>
    </div>
  } @else {
    <div
      [ngClass]="{
        tile: type() === 'home',
        'zero-surface grey-800 mb-4 p-4 b-r-8': type() === 'dividends',
      }"
    >
      <h5 class="zero-text p-bigger-bold d-flex align-items-center mb-2">
        {{ 'my-home.my-home-page.dividend-re-invest-hint.headline' | transloco }}
        <web-design-system-pill class="ml-2" type="new">
          {{ 'my-home.my-home-page.dividend-re-invest-hint.new-badge' | transloco | uppercase }}
        </web-design-system-pill>
      </h5>
      <p class="zero-text p-base-reg label" [innerHTML]="'my-home.my-home-page.dividend-re-invest-hint.text' | transloco"></p>
      <div class="zero-surface grey-800 p-3">
        <web-design-system-checkbox [isChecked]="false" (isCheckedChange)="isCheckboxChecked = $event">
          <span class="zero-text p-big-med" [innerHTML]="'my-home.my-home-page.dividend-re-invest-hint.checkbox' | transloco"> </span>
        </web-design-system-checkbox>
      </div>
      @if (facade.error$ | async; as error) {
        <p class="zero-text course-red">{{ error }}</p>
      }
      <div class="mt-4 d-flex flex-column flex-xl-row justify-content-xl-end align-items-center gap">
        <a
          class="zero-text cursor-pointer p-base-reg link-secondary no-select"
          [class.disabled]="facade.hasOngoingRequest$ | async"
          (click)="facade.decline()"
        >
          {{ 'my-home.my-home-page.dividend-re-invest-hint.actions.no' | transloco }}
        </a>
        <web-design-system-button
          type="secondary"
          size="small"
          [disabled]="(facade.hasOngoingRequest$ | async) || !isCheckboxChecked"
          (click)="facade.activate(25)"
        >
          {{ 'my-home.my-home-page.dividend-re-invest-hint.actions.yes' | transloco: { value: 25 } }}
        </web-design-system-button>
        <web-design-system-button
          type="primary"
          size="small"
          [disabled]="(facade.hasOngoingRequest$ | async) || !isCheckboxChecked"
          (click)="facade.activate(1)"
        >
          {{ 'my-home.my-home-page.dividend-re-invest-hint.actions.yes' | transloco: { value: 1 } }}
        </web-design-system-button>
      </div>
    </div>
  }
}
